import { useState } from "react";
import { motion } from "framer-motion";
import "../../App.css"
import * as api from "../../api/index";


const VolunteerForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    animalType: "",
    reason: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
    // Add form submission logic here
    try{
    const response = await api.adoptionForm(formData);
    if(response.data){
        alert("Form successfully submitted");
    }
    setFormData({
        name: "",
        email: "",
        phone: "",
        location: "",
        animalType: "",
        reason: "",
      });
    }
    catch(error){
        console.log(error); 
        alert("something went wrong");
    }
    
  };

  return (
    <div
      className="flex justify-center items-center min-h-screen bg-gradient-to-br from-indigo-400 via-purple-400 to-pink-400 relative p-6 donation-form-img"
    >
      
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-lg w-full rounded-3xl shadow-2xl p-8 relative z-10"
      >
        <h1 className="text-4xl font-extrabold text-center text-purple-700 mb-6">
        Become a Volunteer and Help Transform Lives! 🐾
        </h1>
        <p className="text-gray-600 text-center mb-8 leading-relaxed">
        Join our mission by volunteering! Make a difference in the lives of animals while creating meaningful connections and memories.
        </p>
        <form onSubmit={handleSubmit} className="space-y-6 donation-form" >
          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="name"
            >
              Name
            </label>
            <input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Your Full Name"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            />
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Your Email Address"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            />
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="phone"
            >
              Phone No.
            </label>
            <input
              id="phone"
              name="phone"
              type="number"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="phone number"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            />
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="location"
            >
              State and city
            </label>
            <input
              id="location"
              name="location"
              type="text"
              value={formData.location}
              onChange={handleInputChange}
              placeholder="Your Location"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            />
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="animalType"
            >
              Have a previous experience in animal NGO
            </label>
            <select
              id="experience"
              name="experience"
              value={formData.experience}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            >
              <option value="" disabled>
                Worked in previous animal NGO ? 
              </option>
              <option value="yes">Yes</option>
              <option value="no">no</option>
            </select>
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="reason"
            >
              Why you want to adopt
            </label>
            <input
              id="reason"
              name="reason"
              value={formData.reason}
              onChange={handleInputChange}
              placeholder="Why you want to adopt"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
            ></input>
          </div>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            type="submit"
            className="stylish-button w-full bg-purple-600 text-white py-3 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
          >
            Adopt Now
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
};

export default VolunteerForm;
